import { onConvertChanged } from '@globals/utils/functions';

onConvertChanged('[data-micromodal-trigger]', (triggers) => {
	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			const modalId = trigger.dataset.micromodalTrigger;

			if (modalId) {
				window.MicroModal.show(modalId, {
					awaitOpenAnimation: true,
					awaitCloseAnimation: true,
					disableScroll: true,
					onShow: () => {
						window.lenis?.stop();
					},
					onClose: () => {
						window.lenis?.start();
					},
				});
			}
		});
	});
});
